import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventBreakDirective } from './directives/event-break.directive';
import { TextDividerPipe } from './pipes/word-divider.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { LocalStorageService } from './services/local-storage.service';



@NgModule({
  declarations: [
    EventBreakDirective,
    TextDividerPipe,
    HighlightPipe,
  ],

  imports: [
    CommonModule
  ],

  providers: [LocalStorageService],

  exports: [
    EventBreakDirective,
    TextDividerPipe,
    HighlightPipe,
  ]
})
export class SharedModule { }
